<nz-list [nzDataSource]="details" [nzRenderItem]="treasureTemplate">
  <ng-template #treasureTemplate let-treasure>
    <nz-list-item>
      <nz-list-item-meta [nzAvatar]="avatar" [nzTitle]="title">
      </nz-list-item-meta>
      <ng-template #title>
        <span [appItemRarity]="treasure">{{treasure | itemName | i18n}}</span>
      </ng-template>
      <ng-template #avatar>
        <app-item-icon [itemId]="treasure" [width]="32"></app-item-icon>
      </ng-template>
    </nz-list-item>
  </ng-template>
</nz-list>
